var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-tooltip-base-content"},[_c('ui-tooltip',{staticClass:"overlay-tooltip-base-content__tooltip",style:(_vm.tooltipStyles),attrs:{"origin-x":_vm.originPosition.x,"origin-y":_vm.originPosition.y,"overlay-x":_vm.overlayPosition.x,"overlay-y":_vm.overlayPosition.y}},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.label))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }